import { create } from "zustand";

import {
  closeSiblingDrawers,
  registerSidebarDrawer,
} from "./sidebar-drawer-coordinator";

interface NotificationsDrawerState {
  isOpen: boolean;
  isLocked: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  lockDrawer: () => void;
}

export const useNotificationsDrawerStore = create<NotificationsDrawerState>(
  (set) => ({
    isOpen: false,
    isLocked: false,
    openDrawer: () => {
      closeSiblingDrawers("notifications");
      set({ isOpen: true });
    },
    closeDrawer: () => set({ isOpen: false, isLocked: false }),
    lockDrawer: () => set({ isLocked: true }),
  }),
);

registerSidebarDrawer("notifications", () =>
  useNotificationsDrawerStore.getState().closeDrawer(),
);
